export const modalTypes = {
  creating: "CREATE",
  editing: "EDIT",
  duplicating: "DUPLICATE"
};

export const getModalTitle = (type, intl, intlPrefix, values) => {
  const { creating, editing, duplicating } = modalTypes;
  switch (type) {
    case creating:
      return intl.formatMessage({ id: `${intlPrefix}-create-title` }, values);
    case editing:
      return intl.formatMessage({ id: `${intlPrefix}-edit-title` }, values);
    case duplicating:
      return intl.formatMessage({ id: `${intlPrefix}-duplicate-title` }, values);
    default:
      return intl.formatMessage({ id: `${intlPrefix}-create-title` }, values);
  };
};

export const getButtonText = (type, intl, intlPrefix) => {
  const { creating, editing, duplicating } = modalTypes;
  switch (type) {
    case creating:
      return intl.formatMessage({ id: `${intlPrefix}-create-text` });
    case editing:
      return intl.formatMessage({ id: `${intlPrefix}-update-text` });
    case duplicating:
      return intl.formatMessage({ id: `${intlPrefix}-duplicate-text` });
    default:
      return intl.formatMessage({ id: `${intlPrefix}-create-text` });
  };
};
